export default __webpack_public_path__ + "static/1-d6021471eeea184f83d0f95229cebc33.png";